import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, NavigationExtras } from '@angular/router';
import { CutsProjectModel } from '@core/model/custProject.model';
import { ItemInformationModel } from '@core/model/itemInformation.model';
import { MasterClientModel } from '@core/model/masterClient.model';
import { SendItemModel } from '@core/model/sendItem.model';
import { SiteModel } from '@core/model/site.model';
import { UserModel } from '@core/model/user.model';
import { environment } from '@env/environment';
import { CommonService } from '@shared/service/common.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ProductFamilyService } from '@shared/service/productFamily.service';
import { utiles } from '@utl/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProductinformationComponent } from '../productinformation/productinformation.component';
import { ModelsService } from '@shared/service/models.service';
import { DvhInfo } from '@core/model/dvhInfo.model';
import { VilaxInfo } from '@core/model/vilaxInfo.model';
import { GlassInfo } from '@core/model/glassInfo.model';
import { PrefaReglasInfo } from '@core/model/prefaReglasinfo.model';
import { model5020Info } from '@core/model/model5020Info.model';
import { model6030Info } from '@core/model/model6030Info.model';
import { model8025Info } from '@core/model/model8025info.model';
import { model8040Info } from '@core/model/model8040info.model';
import { modelM338Info } from '@core/model/modelM338Info.model';
import { modelEuropaCorrInfo } from '@core/model/modelEuropaCorrInfo.model';
import { PrefaSinReglasInfo } from '@core/model/PrefaSinReglasInfo.mode';
import { modelPabLujoInfo } from '@core/model/modelPabLujoInfo.model';

declare var $: any;

@Component({
  selector: 'app-productcard',
  templateUrl: './productcard.component.html',
  styleUrls: ['./productcard.component.scss']
})
export class ProductcardComponent implements OnInit {

  @Input('parentValue')
  set name(parentValue:any) {
    this.itemInfo = parentValue
  }
  @Input() selectedFilters;
  @Input() FamilyId
  @Input() productSearch;
  @Input() productions;
  @Input() callingComponent;
  @Input() carruselType;

  private unsubscribe$ = new Subject<void>();
  masterClientModel: MasterClientModel = new MasterClientModel();
  private userModel: UserModel;
  private siteModel: SiteModel = new SiteModel();
  private currencyModel: any;
  private projectModel: CutsProjectModel = new CutsProjectModel();
  private projectCustomer: CutsProjectModel = new CutsProjectModel();
  imgDefault = environment.imgDefault;
  showModalAdd = false;
  public sendItemModel: SendItemModel = new SendItemModel();
  private modalRef: NgbModalRef
  itemInfo: ItemInformationModel = new ItemInformationModel();
  productImage: any[] = [];
  productName: string;
  imgUrlDefault: string;
  parentValueRec: ItemInformationModel;

  productImageSelected: any;
  productInformation: ItemInformationModel;
  singlePrice: number;
  previewPrice: number;

  constructor(
    private productFamilyService: ProductFamilyService,
    public dialog: MatDialog,
    private common: CommonService,
    private modelsService: ModelsService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.setUserData();

    this.common.SelectedSite.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (site) => {
        if (site !== null) {
          this.siteModel = site;
        }
      }
    );

    // Observable of the selected project
    this.common.SelectedProject.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (project) => {
        if (project !== null) {
          this.projectModel = project;
        }
      }
    );

    this.common.SelectedClient.pipe(takeUntil(this.unsubscribe$)).subscribe(
      (client) => {
        if (client !== null && client !== '') {
          this.projectCustomer = client;
          this.masterClientModel = client;
        }
      }
    );
  }

  ngOnChanges() {
    this.cdr.detectChanges();
  }


  goToDetailProduct(item) {
    if (this.callingComponent !== 'carrusel') {
      let filters = [];
      if (this.selectedFilters !== undefined) {
        this.selectedFilters.forEach((element) => {
          let obj = {
            Filter: element.FilterId,
            Value: element.QueryValue.split(',')[0],
          };
          filters.push(obj);
        });
      }
      let searchProd = {
        Family: this.FamilyId,
        SearchWord: this.productSearch,
        SelectedFilters: filters,
      };
      this.router.navigate(['productdetail'], {
        queryParams: {
          ItemId: item.ItemId,
          searchProd: JSON.stringify(searchProd),
        },
      });
    }
  }

  openModalShoppingCart(item) {

    if (this.callingComponent !== 'carrusel') {
      utiles.clearCacheProductShopping();

      let filters = [];
      if (this.selectedFilters !== undefined) {
        this.selectedFilters.forEach((element) => {
          let obj = {
            Filter: element.FilterId,
            Value: element.QueryValue.split(',')[0],
          };
          filters.push(obj);
        });
      }

      const data = {
        itemInfo : item,
        filters: filters,
        family: this.FamilyId
      }
      utiles.createCacheProductShopping(data);

      const dialogRef = this.dialog.open(ProductinformationComponent, {
        minWidth: '50vw',
        maxWidth: '90vw',
        maxHeight: '90vh',
        minHeight: '60vh',
      });

      dialogRef.componentInstance.onCancel
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((_onlyAdd) => {
          dialogRef.close();
          if (_onlyAdd === false) {
            this.router.navigate(['shoppingcart']);
          }
        });
    }
  }

  addFavorite(item) {

    this.sendItemModel.UserId = this.userModel.UserId;
    this.sendItemModel.ItemId = item.ItemId;
    this.productFamilyService
      .addToFavoriteItems(this.sendItemModel)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          item.Favorite = 1;
        }
      });
  }

  deleteFavorite(item) {
    if (this.callingComponent !== 'whistlist') {
      this.sendItemModel.UserId = this.userModel.UserId;
      this.sendItemModel.ItemId = item.ItemId;
      this.productFamilyService
        .deleteFromFavorite(this.sendItemModel)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => {
          if (response) {
            if (response) {
              item.Favorite = 0;
            }
          }
        });
    }
  }

  setUserData() {
    this.userModel = utiles.getCacheUser();
  }

  carouselCard() {
    let that = this;

    $(document).ready(function() {
      $('.shoppin-cart-card-' + this.itemInfo.ItemId).click(function(e) {


        this.vListItems = [];
        this.vParams = '';
        this.ItemId = '';
        this.FamilyId = '';
        this.vParams = e.currentTarget.name;
        this.vListItems = this.vParams.split(',', 2);

        this.ItemId   = this.vListItems[0];
        this.FamilyId = this.vListItems[1];
        this.FamilyId = this.FamilyId.replace(/\s/g, '');
        let item = { ItemId: this.ItemId, FamilyId: this.FamilyId };
        that.openModalShoppingCart(item);
      });
    });
  }

  goToConfig(ItemId: string, image: string = '') {
    let modelconfigInfo;
    this.modelsService
    .getModelConfigInfo(ItemId)
    .pipe(takeUntil(this.unsubscribe$))
    .subscribe((response) => {
      if (response != null) {
        modelconfigInfo = response[0];
        if (modelconfigInfo.Route !== '') {
          if (modelconfigInfo.Model === 'VIDRIO CORTADO') {
            const vGlassInfo = new GlassInfo();
            vGlassInfo.vRouteModel = modelconfigInfo.Route;
            vGlassInfo.vSoloCotiza = this.itemInfo.OnlyQuotProcess;
            utiles.clearCacheGlassInfo();
            utiles.createCacheGlassInfo(vGlassInfo);
            const navigationExtras: NavigationExtras = {
              queryParams: {
                Model: JSON.stringify(vGlassInfo)
              },
            };
            this.router.navigate([modelconfigInfo.Route], navigationExtras);
          } else if (modelconfigInfo.Model === 'VILAX') {
            const vVilaxInfo = new VilaxInfo();
            vVilaxInfo.vCodArticulo = modelconfigInfo.ItemId;
            vVilaxInfo.vImagen = image;
            vVilaxInfo.vRouteModel = modelconfigInfo.Route;
            vVilaxInfo.vSoloCotiza = this.itemInfo.OnlyQuotProcess;
            utiles.clearCacheVilaxInfo();
            utiles.createCacheVilaxInfo(vVilaxInfo);
            const navigationExtras: NavigationExtras = {
              queryParams: {
                Model: JSON.stringify(vVilaxInfo)
              },
            };
            this.router.navigate([modelconfigInfo.Route], navigationExtras);
          } else if (modelconfigInfo.Model === 'DVH') {
            const vDVH = new DvhInfo();
            vDVH.vCodArticulo = modelconfigInfo.ItemId;
            vDVH.vImagen = image;
            vDVH.vRouteModel = modelconfigInfo.Route;
            vDVH.vSoloCotiza = this.itemInfo.OnlyQuotProcess;
            utiles.clearCacheDVHInfo();
            utiles.createCacheDVHInfo(vDVH);
            const navigationExtras: NavigationExtras = {
              queryParams: {
                Model: JSON.stringify(vDVH)
              },
            };
            this.router.navigate([modelconfigInfo.Route], navigationExtras);
          } else {
            if(modelconfigInfo.Model === 'PUERTA LUJO ABATIBLE') {
              const vPabLujo = new modelPabLujoInfo();
              let vPrefaSinReglas: PrefaSinReglasInfo = vPabLujo;

              vPrefaSinReglas.vCodArticulo = modelconfigInfo.ItemId;
              vPrefaSinReglas.vImagen = image;
              vPrefaSinReglas.vRouteModel = modelconfigInfo.Route;
              vPrefaSinReglas.vSoloCotiza = this.itemInfo.OnlyQuotProcess;
              vPrefaSinReglas.vListaProcesos = modelconfigInfo.ListaProcesos;
              vPrefaSinReglas.vListaAccesorios = modelconfigInfo.ListaAccesorios;
              utiles.clearCachePrefaSinReglasInfo();
              utiles.createCachePrefaSinReglasInfo(vPrefaSinReglas);
              
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  Model: JSON.stringify(vPrefaSinReglas)
                },
              };
              
              this.router.navigate([modelconfigInfo.Route], navigationExtras);
            } else {
              let vPrefaReglas: PrefaReglasInfo;
              if (modelconfigInfo.Model === '5020') {
                const vModel5020 = new model5020Info();
                vPrefaReglas = vModel5020;
              } else if (modelconfigInfo.Model === '6030') {
                const vModel6030 = new model6030Info();
                vPrefaReglas = vModel6030;
              } else if (modelconfigInfo.Model === '8025') {
                const vModel8025 = new model8025Info();
                vPrefaReglas = vModel8025;
              } else if (modelconfigInfo.Model === '8040') {
                const vModel8040 = new model8040Info();
                vPrefaReglas = vModel8040;
              } else if (modelconfigInfo.Model === 'EUROPA CORREDIZA') {
                const vModelEuroCorr = new modelEuropaCorrInfo();
                vPrefaReglas = vModelEuroCorr;
              } else if (modelconfigInfo.Model === 'M338') {
                const vModelM338 = new modelM338Info();
                vPrefaReglas = vModelM338;
              }
  
              vPrefaReglas.vCodArticulo = modelconfigInfo.ItemId;
              vPrefaReglas.vImagen = image;
              vPrefaReglas.vRouteModel = modelconfigInfo.Route;
              vPrefaReglas.vSoloCotiza = this.itemInfo.OnlyQuotProcess;
              vPrefaReglas.vListaProcesos = modelconfigInfo.ListaProcesos;
              vPrefaReglas.vListaAccesorios = modelconfigInfo.ListaAccesorios;
              utiles.clearCachePrefaReglasInfo();
              utiles.createCachePrefaReglasInfo(vPrefaReglas);
              
              const navigationExtras: NavigationExtras = {
                queryParams: {
                  Model: JSON.stringify(vPrefaReglas)
                },
              };
              this.router.navigate([modelconfigInfo.Route], navigationExtras);
            }            
          }
        }
      }
    });
  }
}
